import { z } from 'zod';
export const ptaSupervisoryValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        PlanOfCare: z.boolean().refine((value) => !!value, { message: 'section has errors' }),
        assistantPresent: z.string().optional().nullable(),
        therapeuticExercise: z.array(z.string()).optional(),
        strengthTherapeutic: z.array(z.string()).optional(),
        romTherapeuticExercise: z.array(z.string()).optional(),
        balanceTherapeuticExercise: z.array(z.string()).optional(),
        adlTraining: z.array(z.string()).optional(),
        gaitTraining: z.array(z.string()).optional(),
        stairTraining: z.array(z.string()).optional(),
        painManagement: z.array(z.string()).optional(),
        enduranceManagement: z.array(z.string()).optional(),
        saftyTraining: z.array(z.string()).optional(),
        expectedProgress: z.boolean().optional(),
        minimalProgress: z.boolean().optional(),
        nextVisitPlanComments: z.string().optional(),
        nextVisitPlan: z.boolean().optional(),
    }),
    signedUserId: z.string().min(1, 'required'),
    signedUserDate: z.string().min(1, 'required'),
});
